module.exports = __webpack_public_path__ + "assets/img/bg_18.f8ef3157.png";